import colors from "vuetify/es5/util/colors";

export default {
   name: "Dealer-Knows",
   dark: false,
   scheme: "md-orange-600-scheme",
   primary: colors.orange.darken1,
   secondary: colors.deepPurple.darken2,
// accent: colors.deepPurple.accent2,
   accent: colors.orange.darken1,

};

